import classNames from 'classnames';
import { type ComponentProps, memo } from 'react';

import { XIcon as CloseIcon } from '@air/design-icons';
import { VisuallyHidden } from '@air/primitive-visually-hidden';

export type AlertModalCloseButtonProps = ComponentProps<'button'>;

export const AlertModalCloseButton = memo(({ className, ...restOfProps }: AlertModalCloseButtonProps) => {
  return (
    <button
      className={classNames(
        'flex h-6 w-6 items-center justify-center rounded-4 border-0 bg-transparent ads:text-primary text-gray-12 outline-none hover:ads:bg-hover-subtle hover:bg-gray-4 focus-visible:ads:ring-focus focus-visible:ring-2 focus-visible:ring-blue-9 active:ads:bg-hover-subtle active:bg-gray-4',
        className,
      )}
      {...restOfProps}
    >
      <VisuallyHidden>Close modal</VisuallyHidden>
      <CloseIcon size="sm" />
    </button>
  );
});

AlertModalCloseButton.displayName = 'AlertModalCloseButton';
